<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import DashboardSidebar from '@/components/core/sidebar/DashboardSidebar.vue'
import DashboardNavbar from '@/components/core/DashboardNavbar.vue'
import { useAppStore } from '@/stores/app'
import { useAccountStore } from '@/stores/accountStore'
import { SUPPORT_SUBJECT, supportMailto } from '@/lib/supportMail'

const { t } = useI18n()
const store = useAppStore()
const accountStore = useAccountStore()
const supportHref = computed(() =>
  supportMailto({
    subject: SUPPORT_SUBJECT,
    accountEmail: accountStore.account.email,
  }),
)
</script>

<template>
  <div>
    <DashboardSidebar />
    <div
      class="relative app-container dashboard-main"
      :style="
        typeof store.wrapperLeftOffset === 'number'
          ? {
              left: `${store.wrapperLeftOffset}px`,
              width: `calc(100% - ${store.wrapperWidth}px)`,
            }
          : undefined
      "
    >
      <DashboardNavbar />
      <div class="p-2 lg:p-6 max-w-[1440px] m-auto mt-[64px]">
        <RouterView />
      </div>
      <footer class="border-t border-border mt-8">
        <div
          class="max-w-[1440px] m-auto px-4 lg:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted-foreground"
        >
          <div class="flex gap-4">
            <RouterLink to="/legal/terms" class="hover:text-foreground">{{
              t('legal.termsOfService')
            }}</RouterLink>
            <RouterLink to="/legal/privacy" class="hover:text-foreground">{{
              t('legal.privacyPolicy')
            }}</RouterLink>
            <RouterLink to="/legal/refund" class="hover:text-foreground">{{
              t('legal.refundPolicy')
            }}</RouterLink>
          </div>
          <div>
            {{ t('common.support') }}:
            <a :href="supportHref" class="hover:text-foreground">support@geekfun.club</a>
          </div>
        <span>&copy; {{ new Date().getFullYear() }} GEEKFUN. {{ t('common.copyright') }}</span>
      </div>
    </footer>
    </div>
  </div>
</template>

